import React,{ useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { restoreAuth, logout } from '../store/slices/authSlice';
import authService from '../services/authService';

export const useAuthInit = () => {
  const [isInitializing, setIsInitializing] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');

        console.log('Auth Init - Token:', token ? 'exists' : 'missing');
        console.log('Auth Init - User:', user ? 'exists' : 'missing');

        if (token && user) {
          try {
            // Validate token with backend
            const profileResponse = await authService.getProfile();
            
            if (profileResponse.success) {
              // Token is valid, restore user session
              const userData = JSON.parse(user);
              dispatch(restoreAuth({
                user: userData,
                token: token,
                refreshToken: localStorage.getItem('refreshToken') || ''
              }));
            } else {
              // Token is invalid, clear auth data
              dispatch(logout());
            }
          } catch (error) {
            console.error('Auth Init - Token validation error:', error);
            // Token validation failed, clear auth data
            dispatch(logout());
          }
        } else {
          // No stored auth data, ensure logged out state
          dispatch(logout());
        }
      } catch (error) {
        console.error('Auth Init - General error:', error);
        dispatch(logout());
      } finally {
        setIsInitializing(false);
      }
    };

    initializeAuth();
  }, [dispatch]);

  return { isInitializing };
};
